import { render, staticRenderFns } from "./Novices.vue?vue&type=template&id=11686be2&scoped=true&"
import script from "./Novices.vue?vue&type=script&lang=js&"
export * from "./Novices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11686be2",
  null
  
)

export default component.exports